module.exports = __webpack_public_path__ + "static/img/img_form1_en.86a81e89.png";